/**
 * Created by denis.gusarov on 4/27/2017.
 */

namespace Factive.Game {
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;

    export class ResultTableRowView extends ViewBase {

        public $model: IResultTableRowModel;

        public constructor(private _options) {
            super();
        }

        public static factory: any = {
            get (opt): ResultTableRowView {
                return new ResultTableRowView(opt);
            },
            dependency: ["Options"]
        };

        public getConfiguration(): IViewConfiguration {
            var assetScale:number = .5;
            return <IViewConfiguration>{
                armatureName: "ResultTableRow",
                childViews: {
                    namelabelView: {
                        view: "LabelView",
                        x: -200*assetScale,
                        y: -40*assetScale,
                        options: {
                            text: this.$model.name,
                            fontSize: 30*assetScale,
                            fontFamily: 'MLBArialNarrow',
                            fill: '#ffffff',
                            align: 'left',
                            wordWrap : true,
                            wordWrapWidth : 200
                        }
                    },
                    x1: {
                        view: "LabelView",
                        x: 40*assetScale,
                        y: -40*assetScale,
                        options: {
                            text: this.$model.x1,
                            fontSize: 24*assetScale,
                            fontFamily: 'MLBArialNarrow',
                            fill: '#ffffff',
                            align: 'left',
                            wordWrap : true,
                            wordWrapWidth : 200
                        }
                    },
                    x2: {
                        view: "LabelView",
                        x: 120*assetScale,
                        y: -40*assetScale,
                        options: {
                            text: this.$model.x2,
                            fontSize: 12,
                            fontFamily: 'MLBArialNarrow',
                            fill: '#ffffff',
                            align: 'left',
                            wordWrap : true,
                            wordWrapWidth : 200
                        }
                    },
                    x3: {
                        view: "LabelView",
                        x: 200*assetScale,
                        y: -40*assetScale,
                        options: {
                            text: this.$model.x3,
                            fontSize: 24*assetScale,
                            fontFamily: 'MLBArialNarrow',
                            fill: '#ffffff',
                            align: 'left',
                            wordWrap : true,
                            wordWrapWidth : 200
                        }
                    }
                },
                modelWatch:{
                    "x1": (newVal, oldVal) => {
                        this.$childViews.get<LabelView>("x1").text = newVal;
                    },
                    "x2": (newVal, oldVal) => {
                        this.$childViews.get<LabelView>("x2").text = newVal;
                    },
                    "x3": (newVal, oldVal) => {
                        this.$childViews.get<LabelView>("x3").text = newVal;
                    },
                }
            };
        }

        protected onContentLoaded(){
        }

        protected onSetLandscape(){
        }

        protected onSetPortrait(){
        }

        public onInitialize(): void {
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Game/ResultTableRowView.ts